import { useInfiniteQuery, useMutation } from 'react-query';
import { YardReportListRequest } from './yard-report.types';
import yardReportServices from './yard-report.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';

const YARD_REPORT_LIST_KEY = 'yard-report/list';

export function useYardReport() {
  return useMutation({
    mutationFn: yardReportServices.report,
    onSuccess: () => {
      notification.success({
        message: 'O relatório de Gestão de Pátio foi gerado com sucesso',
      });
    },
    onError: (error) => {
      notificationError(error);
    },
  });
}

export function useYardReportList(
  params?: YardReportListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [YARD_REPORT_LIST_KEY, { ...params }],
    queryFn: ({ pageParam }) =>
      yardReportServices.list({
        limit: 10,
        nextToken: pageParam,
        responseType: 'Json',
        ...params,
      } as YardReportListRequest),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: enabled && !!params?.companyIds?.length,
  });
}
